import { Component, ErrorInfo, ReactNode } from "react";
import { reportCrash } from "../lib/crashReporter";
import ErrorPage from "./errorPage";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    void reportCrash("render", error, { componentStack: errorInfo.componentStack ?? "" });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return <ErrorPage />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
